import React, { createContext, useContext, useEffect, useState } from "react";
import useAuth from '../hooks/useAuth';
import { WS_URL,LOGOUT_URL } from '../config'


const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [messages, setMessages] = useState([]);
    const auth = useAuth();
    const user = auth?.auth?.user;
    useEffect(() => {
        if (!user) return;
        const ws = new WebSocket(`${WS_URL}?username=${user.username}`);

        ws.onopen = () => {
            console.log('Connected to WebSocket server');
            ws.send('Hello Server');
        };

        ws.onmessage = async (event) => {
            try {
                let data;
                if (event.data instanceof Blob) {
                    const text = await event.data.text();
                    console.log('Received:', text);
                    data = JSON.parse(text);
                } else {
                    console.log('Received:', event.data);
                    data = JSON.parse(event.data);
                }

                if (data.type === 'onlineUsers') {
                    setOnlineUsers(data.users);
                } else {
                    setMessages((prevMessages) => [...prevMessages, { message: data.message, sender: data.sender } || data]);
                }
            } catch (error) {
                console.error('Error parsing WebSocket message:', error);
            }
        };

        ws.onerror = (error) => {
            console.error('WebSocket Error:', error);
        };

        ws.onclose = async (event) => {
            console.log('WebSocket closed by ');
            if (user) {
                try {
                    await fetch(`${LOGOUT_URL}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${auth.auth?.token}`,
                        },
                        body: JSON.stringify({ username: user.username }),
                    });
                } catch (error) {
                    console.error("Failed to log out user on unload:", error);
                }
            }

        };
        const handleUnload = async () => {
            if (user) {
                try {
                    await fetch(`${LOGOUT_URL}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${auth.auth?.token}`,
                        },
                        body: JSON.stringify({ username: user.username }),
                    });
                } catch (error) {
                    console.error("Failed to log out user on unload:", error);
                }
            }
        };
    
        window.addEventListener("beforeunload", handleUnload);

        setSocket(ws);

        return () => {
            window.removeEventListener("beforeunload", handleUnload);
            ws.close();
        };
    }, [user]);

    return (
        <WebSocketContext.Provider value={{ socket, onlineUsers,messages }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => useContext(WebSocketContext);
